module.exports = __webpack_public_path__ + "static/img/logo-vertical-ministerio-justicia.b2970aa.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo-vertical-ministerio-justicia.jpeg
// module id = d2oX
// module chunks = 9